import { useTranslation } from 'react-i18next';

import { AppearanceSettings } from '@/components/settings/AppearanceSettings';

/**
 * Appearance panel — theme presets + custom colours (AppearanceSettings) and
 * the compact-banner layout toggle. Banner selection lives in the Profilo
 * "Banner & Avatar" section, not here. Reached from the Profilo "Settings" block.
 */
export function Appearance() {
  const { t } = useTranslation('general');

  return (
    <div className="flex flex-col gap-6 px-4 pb-6 pt-5">
      <header>
        <h1 className="text-2xl font-bold text-fg">
          {t('appearance', { defaultValue: 'Appearance' })}
        </h1>
      </header>

      {/* Theme presets + custom colours + reset */}
      <AppearanceSettings />

      {/* L'interruttore "banner compatto" non c'e' piu': la compressione e' una
          conseguenza dello scroll, non una preferenza. Lasciarlo qui avrebbe
          creato una contraddizione — un utente che lo spegne e vede il banner
          comprimersi comunque appena scorre. */}
    </div>
  );
}
